/**
 * Apply the default Discover access rules after the API has enforced exclusive
 * specific-user audiences. A restricted tool returned for a non-admin user is
 * therefore already authorized for that user.
 */
export const toolMatchesDefaultAccess = (
  tool,
  accessDepartment,
  accessPersona,
  grantedToolIds = []
) => {
  if (tool?.hasSpecificUserAudience) return true;
  if (grantedToolIds.includes(tool?.id)) return true;

  const toolDepartments = Array.isArray(tool?.departments)
    ? tool.departments.filter((department) => String(department || '').trim())
    : [];

  const department = String(accessDepartment || '').trim().toLowerCase();
  const departmentMatch = department && toolDepartments.some(
    (value) => String(value || '').trim().toLowerCase() === department
  );
  if (departmentMatch) return true;

  const personas = (Array.isArray(accessPersona) ? accessPersona : [accessPersona])
    .map((value) => String(value || '').trim().toLowerCase())
    .filter(Boolean);
  const toolPersona = String(tool?.persona || '').trim().toLowerCase();
  if (toolPersona && personas.includes(toolPersona)) return true;

  // Preserve the legacy catalog behavior for tools that were never scoped to
  // a department. Existing Apps and Gems must not disappear after this feature.
  return toolDepartments.length === 0;
};
